import { useEffect, useState } from 'react';
import styles from './ReloadPage.module.scss';

type ReloadPageProps = {
  versionName: string;
};

export default function ReloadPage({
  versionName,
}: ReloadPageProps) {
  // Time left in seconds.
  const [ timeLeft, setTimeLeft ] = useState(10);

  useEffect(() => {
    if (timeLeft === 0) {
      window.location.reload();
      return;
    }

    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [ timeLeft ]);

  return (
    <div className={styles.reloadPage}>
      <p>&quot;{versionName}&quot; is not available yet.
        <br />
        {timeLeft ? `Will retry in ${timeLeft} seconds...` : 'Reloading...'}
      </p>
    </div>
  );
}
